import { useTranslation } from 'react-i18next';

export function LoadingScreen() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-beige via-white to-brand-beige flex items-center justify-center">
      <div className="text-center">
        {/* Animated Logo Container */}
        <div className="relative">
          {/* Pulsing background circle */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 rounded-full bg-brand-terracotta/10 animate-ping mt-8"/>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">            
          </div>
                    
        </div>

        {/* Animated brand name */}
        <h1 className="text-4xl font-bold mb-4 overflow-hidden">
          <span className="inline-block">
            {'immopersian'.split('').map((char, index) => (
              <span
                key={index}
                className="inline-block animate-wave text-brand-dark"
                style={{
                  animationDelay: `${index * 0.05}s`,
                }}
              >
                {char}
              </span>
            ))}
          </span>
        </h1>

        {/* Loading dots */}
        <div className="flex items-center justify-center gap-2 mb-4">
          {/* <span className="text-brand-dark/70">{t('common.loading')}</span> */}
          <div className="flex gap-1">
            <span className="w-2 h-2 bg-brand-terracotta rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
            <span className="w-2 h-2 bg-brand-terracotta rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
            <span className="w-2 h-2 bg-brand-terracotta rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
          </div>
        </div>

        
      </div>

      {/* Custom animations */}
      <style>{`
        @keyframes wave {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(200%); }
        }
        
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        
        .animate-wave {
          animation: wave 1.5s ease-in-out infinite;
        }
        
        .animate-shimmer {
          animation: shimmer 2s ease-in-out infinite;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.6s ease-out forwards;
        }
      `}</style>
    </div>
  );
}

